import React from 'react';
import { useLocation } from 'react-router-dom';
import SimpleTabs from '../../../../components/tabs/simpleTabs';
import HubspotTabIcon from '../../../../assets/icons/tab/hubspot-tab-icon.svg';
import SalesforceTabIcon from '../../../../assets/icons/tab/salesforce-tab-icon.svg';
import MondayTabIcon from '../../../../assets/icons/tab/monday-tab-icon.svg';
import { CRMTabLinks } from '../../../../components/enums/tabEnums';
import { useOrganizationSettingsStore } from '../../../../store/organizationSettingsStore';
import DisconnectHubspot from '../../../../components/disconnectHubspot/disconnectHubspot';

const Crm = () => {
  const location = useLocation();
  const activePanel = CRMTabLinks[location.pathname.split('/').pop() as keyof typeof CRMTabLinks] || 0;
  const organizationSettings = useOrganizationSettingsStore((state) => state.organizationSettings);

  return (
    <div className={`${organizationSettings.isConnectedToHubspot ? 'h-full' : 'h-[83vh]'}`}>
      <div className={`${organizationSettings.isConnectedToHubspot ? 'h-[91%]' : 'h-full'} 
      rounded-lg border border-dark bg-white   px-6 py-4`}
      >
        <SimpleTabs
          currentTab={activePanel}
          tabs={[
            {
              tabLabel: 'Hubspot',
              href: 'hubspot',
              identifierName: 'hubspot-panel',
              icon: HubspotTabIcon,
            },
            {
              tabLabel: 'Salesforce',
              href: 'salesforce',
              identifierName: 'salesforce-panel',
              icon: SalesforceTabIcon,
            },
            {
              tabLabel: 'Monday.com',
              href: 'monday',
              identifierName: 'monday-panel',
              icon: MondayTabIcon,
            },
          ]}
        />
      </div>
      {organizationSettings.isConnectedToHubspot && <DisconnectHubspot />}
    </div>
  );
};

export default Crm;
